
      // Este script verifica se o React está carregando corretamente
      document.addEventListener('DOMContentLoaded', () => {
        // Se após 2 segundos o conteúdo não for renderizado, mostrar mensagem de fallback
        setTimeout(() => {
          const root = document.getElementById('root');
          if (!root.hasChildNodes()) {
            root.innerHTML = `
              <div class="light-mapper-container">
                <div class="toolbar">
                  <h1 style="color: white; margin: 0;">Mapeador de Luzes</h1>
                </div>
                <div class="content">
                  <div class="drawing-area">
                    <div style="padding: 20px; text-align: center;">
                      <h2>Carregando aplicação...</h2>
                      <p>Se esta mensagem persistir, verifique os erros no console do navegador.</p>
                    </div>
                  </div>
                </div>
              </div>
            `;
          }
        }, 2000);
      });
    